/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';
// .cls-1{fill:#49536b;stroke:#49536b;stroke-width:3px;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-2{fill:#6cc;stroke:#6cc;stroke-width:2px;}

export const SvgDelivery = ({ size }) => {
    return (<Svg
        viewBox="0 0 98.52 43.61"
        height={size}
        width={size}
    >
        <Path
            fill="#49536b"
            stroke="#49536b"
            strokeWidth="3"
            class="cls-1"
            d="M95.92,18.38h-3.4l-2-11.32a1.22,1.22,0,0,0-1.19-1H75.57V2.82a1.22,1.22,0,0,0-1.22-1.21H31.53a1.21,1.21,0,0,0-1.22,1.21V34.73a1.22,1.22,0,0,0,1.22,1.22h6.17a7.5,7.5,0,0,0,14.79,0H75.1a7.49,7.49,0,0,0,14.79,0h6a1.21,1.21,0,0,0,1.21-1.22V19.59A1.21,1.21,0,0,0,95.92,18.38ZM50.15,35a5.07,5.07,0,1,1,0-.61A5.64,5.64,0,0,1,50.15,35ZM82.5,39.8A5.08,5.08,0,0,1,77.44,35c0-.14,0-.42,0-.54A5.07,5.07,0,1,1,82.5,39.8ZM94.7,33.51H89.89a7.49,7.49,0,0,0-14.79,0H52.49a7.5,7.5,0,0,0-14.79,0h-5V4h40.4V19.95a1.21,1.21,0,1,0,2.43,0V8.5H88.33l2,11.31a1.21,1.21,0,0,0,1.2,1h3.2Z"
            transform="translate(-0.11 -0.11)" />
        <Path
            strokeMiterlimit={10}
            fill="#6cc"
            stroke="#6cc"
            strokeWidth="2"
            class="cls-2"
            d="M20.22,24.7H4.89a1.21,1.21,0,1,0,0,2.43H20.22a1.21,1.21,0,0,0,0-2.43Z"
            transform="translate(-0.11 -0.11)" />
        <Path
            strokeMiterlimit={10}
            fill="#6cc"
            stroke="#6cc"
            strokeWidth="2"
            class="cls-2" d="M20.22,10.42H2.32a1.21,1.21,0,1,0,0,2.42h17.9a1.21,1.21,0,1,0,0-2.42Z"
            transform="translate(-0.11 -0.11)" />
        <Path
            strokeMiterlimit={10}
            fill="#6cc"
            stroke="#6cc"
            strokeWidth="2"
            class="cls-2" d="M20.22,17.56H9.46a1.21,1.21,0,1,0,0,2.43H20.22a1.21,1.21,0,0,0,0-2.43Z"
            transform="translate(-0.11 -0.11)" />

    </Svg>)
}

